import type { FC } from "react";

interface AboutTabProps {
  APP_META: any;
  Card: any;
  CardHeader: any;
  CardTitle: any;
  CardContent: any;
  HelpCircle: any;
}

export const AboutTab: FC<AboutTabProps> = ({
  APP_META,
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  HelpCircle,
}) => (
  <div className="space-y-3 sm:space-y-4">
    <h4 className="text-sm sm:text-lg font-semibold text-foreground">About ChatMCP</h4>
    <p className="text-xs sm:text-sm text-muted-foreground">
      {APP_META.description}
    </p>
    <Card>
      {/* <CardHeader className="p-3 sm:p-6">
        <CardTitle className="flex items-center space-x-1.5 sm:space-x-2 text-sm sm:text-base">
          <HelpCircle className="h-3.5 w-3.5 sm:h-5 sm:w-5" />
          <span>Support</span>
        </CardTitle>
      </CardHeader> */}
      <CardContent className="space-y-2 sm:space-y-3 p-3 sm:p-6 pt-0">
        <a
          href="https://docs.mcp.com.ai"
          target="_blank"
          rel="noopener noreferrer"
          className="block"
        >
          Help & FAQ
        </a>
        <a
          href="https://go.rebelion.la/contact-us"
          target="_blank"
          rel="noopener noreferrer"
          className="block"
        >
          Contact Support
        </a>
        <span className="block"><a href="https://mcp.com.ai/privacy">Privacy Policy</a></span>
        <span className="block"><a href="https://mcp.com.ai/terms">Terms of Service</a></span>
      <p className="text-[9px] sm:text-xs text-gray-500">
        {APP_META.name} v{APP_META.version}
      </p>
      <p className="text-[10px] sm:text-sm text-muted-foreground">
        Visit our{" "}
        <a href="https://github.com/la-rebelion/chatmcp" target="_blank" rel="noopener noreferrer" className="text-primary underline">
          GitHub repository
        </a>, and homepage <a href={APP_META.homepage} target="_blank" rel="noopener noreferrer" className="text-primary underline">{APP_META.homepage}</a>.
      </p>
      </CardContent>
    </Card>
    <div className="pt-2 sm:pt-4 text-center">
      <p className="text-[9px] sm:text-xs text-gray-500 mb-1">
        By using HAPI MCP Stack, you agree to our <a href="https://mcp.com.ai/terms">Terms of Service</a> and <a href="https://mcp.com.ai/privacy">Privacy Policy</a>. We use cookies and similar technologies to operate and improve the service. Your data remains yours.
      </p>
      <p className="text-[9px] sm:text-sm text-muted-foreground mb-1">
        {new Date().getFullYear()} {APP_META.author}. All rights reserved.
      </p>
    </div>
  </div>
);
